import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';
import { BasketModel } from '../models/basket';

@Injectable({
  providedIn: 'root',
})
export class BasketService extends OfflineDataService<BasketModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService,
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Warehouse::Basket',
      http,
      errorService,
      events,
      'warehouse/baskets/',
      'warehouse_basket',
      ['type'],
      ['positions'],
      'bufferstock_id',
    );

    this.bulkSize = 5;
    this.bulkSyncActive = true;
  }

  /**
   * Name des Icons für die Klasse
   * @return {string}
   */
  public get iconName(): string {
    return 'archive-outline';
  }
}
